import AuthRoute from './Auth';

export default {
  name: 'Auth',
  location: '/login',
  component: AuthRoute,
};
